import { CarServiceEstimateBuilder } from './../builders/car-service-estimate-builder';
import { CarServiceFamilyBuilder } from './../builders/car-service-family-builder';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AuthenticationService } from './../services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
import * as i3 from "./../services/authentication.service";
export class CarServicesApiService {
    constructor(api, unauthApi, auth) {
        this.api = api;
        this.unauthApi = unauthApi;
        this.auth = auth;
    }
    listServices() {
        return this.unauthApi.get(`/carservice/list_all`).toPromise().then(response => {
            return response['car_services'].map(family => {
                return CarServiceFamilyBuilder.buildCarServiceFamily(family);
            });
        });
    }
    getCarserviceEstimate(params) {
        const payload = Object.assign({}, params);
        let access_token = this.auth.getAccessToken();
        if (!access_token) {
            return this.unauthApi.get(`/carservice/estimate`, payload).toPromise().then(response => {
                return CarServiceEstimateBuilder.buildCarServiceEstimate(response['car_service_estimate']);
            });
        }
        else {
            return this.api.get(`/carservice/estimate`, payload).toPromise().then(response => {
                return CarServiceEstimateBuilder.buildCarServiceEstimate(response['car_service_estimate']);
            });
        }
    }
}
CarServicesApiService.ɵfac = function CarServicesApiService_Factory(t) { return new (t || CarServicesApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.AuthenticationService)); };
CarServicesApiService.ɵprov = i0.ɵɵdefineInjectable({ token: CarServicesApiService, factory: CarServicesApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(CarServicesApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }, { type: i3.AuthenticationService }]; }, null); })();
//# sourceMappingURL=car-services-api.service.js.map